<template>
    <div class="container mt-2" title="รับชำระเงินกรณีเป็นรายการเครดิต">
        <div class="card border-secondary mb-3" >
            <div class="card-header" style="background-color: #ffc6b3;">
                <div class="row">
                    <div class="col-2 text-start">
                        <button type="button" class="btn btn-success btn-sm" @click="backPage()">ย้อนกลับ</button>
                    </div>
                    <div class="col d-flex justify-content-end"> <span class="rounded-pill text-white bg-danger px-3 pt-1">รับชำระเงิน</span> </div>
                    <!-- <div class="col"><h5 class="rounded-pill text-white bg-danger pt-2">แก้ไขใบสั่งตรวจ</h5> </div> -->
                </div>
            </div>
            <div class="card-body" >
                <div class="row pt-2 text-start mb-2">
                    <form id="fmRO" @submit.prevent="" >
                        <div class="row mb-1">
                            <div class="col-5 text-start">
                                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                                <input type="text" hidden class="form-control" placeholder="" name="action" v-model="action" >
                                <input type="text" hidden class="form-control" placeholder="" name="id" >
                                <div class="input-group input-group-sm mb-3">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">สาขา* :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="curRecordHd.BranchID" disabled>
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                                    </select>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">เลขที่* :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm bg-light" ref="RONo" id="RONo" name="RONo" v-model="curRecordHd.RONo" readonly>
                                    <!-- <button type="button" class="btn btn-info mx-1" @click="autoRONO()" style="width:100px;">Auto</button> -->
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">วันที่* :</span>
                                    </div>
                                    <v-date-picker mode="date" v-model="curRecordHd.DocDate" :masks="masks">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input name="DocDate" ref="DocDate" disabled
                                            class="bg-white border px-2 py-1 rounded"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            />
                                        </template>
                                    </v-date-picker>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ชื่อคนไข้ * :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="PatName" name="PatName" v-model="curRecordHd.PatName" disabled>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">นามสกุล * :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="PatLName" name="PatLName" v-model="curRecordHd.PatLName" disabled>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">หน่วยงานบริษัท :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="ReqClinicID" name="ReqClinicID" v-model="curRecordHd.ReqClinicID" disabled>
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataCliniclists" :key="item.ReqClinicID" :value="item.ReqClinicID">{{ item.ReqClinicName }}</option>
                                    </select>
                                    <!-- <input type="text" class="form-control form-control-sm" name="reqclinic" v-model="curRecordHd.ReqClinicName"> -->
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">HN No. :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="HNNo" name="HNNo" v-model="curRecordHd.HNNo" disabled>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ผู้บันทึก * :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="OfficerID1" name="OfficerID1" v-model="curRecordHd.OfficerID1" disabled>
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataOfficerlists" :key="item.UserID" :value="item.UserID">{{ item.OfficialName }} ({{item.Username}})</option>
                                    </select>
                                    <!-- <input type="text" class="form-control form-control-sm" name="officer1" v-model="curRecordHd.OfficerName1"> -->
                                </div>
                                <div class="input-group input-group-sm mb-2">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">หมายเหตุ :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="Remark" name="Remark" v-model="curRecordHd.Remark" disabled>
                                </div>
                                <br>
                                <div class="row mb-1">
                                    <div class="col">
                                        <button type="button" class="btn btn-primary btn-sm mx-1" style="width:100%;" v-if="curRecordHd.RcptID==0"
                                          id="Edit" title="รับชำระเงิน" data-bs-toggle="modal" data-bs-target="#rcptPaymentModal" >Pay</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-7">
                                <div class="row bg-light mb-1">
                                    <table id="myRODetailTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                                        <thead class="text-white" style="background:black">
                                        <tr>
                                            <!-- <th >รหัสคลินิก</th> -->
                                            <th>รหัสชุดตรวจ</th>
                                            <th>ชุดตรวจ</th>
                                            <th>Specimen</th>
                                            <th>ราคา</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in dataDtllists" :key="item.TestID">
                                            <td class="text-start">{{index+1}}. {{ item.TestCode }}</td>
                                            <td class="text-start">{{ item.TestName }}</td>
                                            <td class="text-start">{{ item.Specimen }}</td>
                                            <td class="text-start">{{ numeralFormat(item.UnitPrice, '0,0[.]00') }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- รวมเป็นเงิน -->
                                <div class="row mb-1">
                                    <div class="col-6">
                                        <div class="input-group input-group-sm  mt-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" style="width:120px;">การชำระเงิน :</span>
                                            </div>
                                            <div class="form-check form-check-inline py-1 ms-2">
                                                <input class="form-check-input" type="radio" name="PayType" id="rdPayType1" value="0" v-model="curRecordHd.PayType" disabled>
                                                <label class="form-check-label" for="rdPayType1">เงินสด</label>
                                            </div>
                                            <div class="form-check form-check-inline py-1">
                                                <input class="form-check-input" type="radio" name="PayType" id="rdPayType2" value="1" v-model="curRecordHd.PayType" disabled>
                                                <label class="form-check-label" for="rdPayType2">เครดิต</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">รวมเป็นเงิน</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.TotalAmt" disabled>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">ส่วนลด</span>
                                            <input type="number" class="form-control bg-light" v-model="curRecordHd.DiscRate" min="0" @change="calculateAmountMaster()" readonly>
                                            <input type="number" class="form-control bg-light" v-model="curRecordHd.DiscAmt"  min="0" :max="curRecordHd.TotalAmt" @change="calculateAmountMaster()" readonly>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">VAT</span>
                                            <input type="number" class="form-control bg-light" v-model="curRecordHd.VatRate" min="0" max="15" @change="calculateAmountMaster()" disabled>
                                            <input type="number" class="form-control bg-light" v-model="curRecordHd.VatAmt" disabled>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">สุทธิ</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.NetAmt" disabled>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    <br>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal รับชำระเงินโดย.. -->
    <div id="rcptPaymentModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">Payment | รับชำระโดย</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <LabPaidCredit3Payment1 :key="countRefreshPayment"
                :rowEdit="curRecordHd"
                 @onBackPageAfterSaveEvent="backPageAfterSave">></LabPaidCredit3Payment1>
            <!-- <LabPaid3Payment :datalists="datalists" :key="countRefresh"
                @onEditRecordEvent="editRecord"
                @onBackPageAfterSaveEvent="backPageAfterSave"></LabPaid3Payment> -->
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'
import LabPaidCredit3Payment1 from './LabPaidCredit3Payment.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'LabCreate2New',
  data () {
    return {
      countRefreshPayment: 0,

      masks: {
        input: 'YYYY-MM-DD'
      },
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      lastRONo: null,
      // รายชื่อคนไข้เดิมที่ค้นหาจากคำค้นหา ใน Modal
      findTextPatient: '',
      dataPatientFindlists: [],

      // Specimen ของชุดตรวจที่คลิกเลือก เป็น string with comma
      curRowIndexDtl: 0,
      // เก็บรายการชุดตรวจที่เพิ่มเข้ามา : RO-Detail
      dataDtllists: [],
      // Master
      curRecordHd: {
        BranchID: this.globalBranchID,
        ROID: 0,
        RONo: '',
        DocDate: new Date(),
        DocTime: this.getTimeNow(),
        PatID: 0,
        PatName: '',
        PatLName: '',
        ReqClinicID: 0,
        HNNo: '',
        OfficerID1: 0,
        OfficerName1: '',
        Remark: '',
        TotalAmt: 0.0,
        DiscRate: 0.0,
        DiscAmt: 0.0,
        TotalAmt_BfVat: 0.0,
        VatRate: 0.0,
        VatAmt: 0.0,
        NetAmt: 0.0,
        RefundAmt: 0.0,
        RcptID: 0, // ID ใบเสร็จกรณีที่รับชำระแล้ว เช็คเพื่อซ่อนปุ่ม Pay
        PayType: 0,
        EarnestAmt: 0.0,
        Status: 0
      },
      action: 'new'
    }
  },
  props: ['rowEdit', 'dataTestSuitlists', 'dataCliniclists', 'dataOfficerlists', 'dataBranchlists', 'dataSpecimenlists'],
  mounted () {
    this.assignDataMaster()
    this.getDataDetail()
    this.countRefreshPayment++
  },
  components: {
    LabPaidCredit3Payment1
  },
  methods: {
    // ดึง DETAIL : รายการเทสในใบสั่งตรวจ
    getDataDetail () {
      var ROID = this.rowEdit.ROID
      MyApiClient.get('getdata/reqdtl_where_id.php?ID=' + ROID)
        .then((resp) => {
          this.dataDtllists = resp.data.response
          if (this.dataDtllists == null) {
            this.dataDtllists = []
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // setTimeout(function () { $('#myRODetailTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getDataMaster () {
      // ใช้การ assign (function assignDataMaster) ค่าให้แทนการดึงจาก API
    },
    assignDataMaster () {
      this.curRecordHd.BranchID = this.rowEdit.BranchID
      this.curRecordHd.ROID = this.rowEdit.ROID
      this.curRecordHd.RONo = this.rowEdit.RONo
      this.curRecordHd.DocDate = this.rowEdit.DocDate
      this.curRecordHd.DocTime = this.rowEdit.DocTime
      this.curRecordHd.PatID = this.rowEdit.PatID
      this.curRecordHd.PatName = this.rowEdit.PatName
      this.curRecordHd.PatLName = this.rowEdit.PatLName
      this.curRecordHd.ReqClinicID = this.rowEdit.ReqClinicID
      this.curRecordHd.HNNo = this.rowEdit.HNNo
      this.curRecordHd.OfficerID1 = this.rowEdit.OfficerID1
      // this.curRecordHd.OfficerName1 = this.rowEdit.OfficerName1
      this.curRecordHd.Remark = this.rowEdit.Remark
      this.curRecordHd.TotalAmt = this.rowEdit.TotalAmt
      this.curRecordHd.DiscRate = this.rowEdit.DiscRate
      this.curRecordHd.DiscAmt = this.rowEdit.DiscAmt
      this.curRecordHd.TotalAmt_BfVat = this.rowEdit.TotalAmt_BfVat
      this.curRecordHd.VatRate = this.rowEdit.VatRate
      this.curRecordHd.VatAmt = this.rowEdit.VatAmt
      this.curRecordHd.NetAmt = this.rowEdit.NetAmt
      this.curRecordHd.RcptID = this.rowEdit.RcptID
      this.curRecordHd.PayType = this.rowEdit.PayType
      this.curRecordHd.EarnestAmt = this.rowEdit.EarnestAmt
      this.curRecordHd.Status = this.rowEdit.Status
    },
    calculateAmountMaster () {
      let totalAmt = 0
      for (let i = 0; i < this.dataDtllists.length; i++) {
        totalAmt = totalAmt + parseFloat(this.dataDtllists[i].UnitPrice)
      }
      // รวมเป็นเงิน
      this.curRecordHd.TotalAmt = totalAmt
      // เปอร์เซ็นต์ส่วนลด, ส่วนลดเป็นเงิน, จำนวนเงินหลังหักส่วนลด
      if (Number(this.curRecordHd.DiscRate) === Number(0)) {
        this.curRecordHd.TotalAmt_BfVat = this.curRecordHd.TotalAmt - this.curRecordHd.DiscAmt
      } else {
        this.curRecordHd.DiscAmt = (this.curRecordHd.TotalAmt * this.curRecordHd.DiscRate) / 100
        this.curRecordHd.TotalAmt_BfVat = this.curRecordHd.TotalAmt - this.curRecordHd.DiscAmt
      }
      // อัตราภาษีมูลค่าเพิ่ม, ภาษีมูลค่าเพิ่มเป็นเงิน, จำนวนเงินสุทธิ
      this.curRecordHd.VatAmt = (this.curRecordHd.TotalAmt_BfVat * this.curRecordHd.VatRate) / 100
      this.curRecordHd.NetAmt = this.curRecordHd.TotalAmt_BfVat + this.curRecordHd.VatAmt
    },
    getToday () {
      return new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    },
    getTimeNow () {
      const today = new Date()
      const h = today.getHours()
      let m = today.getMinutes()
      let s = today.getSeconds()
      if (m < 10) { m = '0' + m }
      if (s < 10) { s = '0' + s }

      return (h + ':' + m + ':' + s)
    },
    backPage () {
      this.$emit('onBackPageEvent')
    },
    // Callback หลังจาก 1-รับชำระเงิน (LabPaid3Payment)
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    }
  }
}
</script>

<style>

</style>
